// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"fed181ebe1edffac7065","293":"8f18ca347bdb1b70768a","518":"78f634ebe9700ee9b35b","779":"9579185a4a21385e6bc4"}[chunkId] + ".js";
};